import React from "react";
import { useNavigate } from "react-router-dom";

export default function DisclaimerPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <button onClick={() => navigate(-1)} style={styles.backButton}>
          ← Back
        </button>

        <h1 style={styles.title}>Disclaimer</h1>

        <p style={styles.date}>Last updated: May 2026</p>

        <p>
          AskUniverse is operated by SC IMAA 888 SRL, Romania.
        </p>

        <h2 style={styles.h2}>Entertainment and Personal Reflection</h2>

        <p>
          AskUniverse provides AI-generated content, dream interpretations,
          tarot-inspired guidance, spiritual insights, daily messages,
          Love Portal experiences, soulmate and twin flame interpretations,
          compatibility insights, relationship reflections, and interactive
          experiences intended for entertainment, inspiration, self-reflection,
          and personal insight purposes only.
        </p>

        <h2 style={styles.h2}>No Professional Advice</h2>

        <p>
          The application does not provide medical, psychological, legal,
          financial, therapeutic, romantic, relationship, or professional advice
          of any kind.
        </p>

        <p>
          The application does not guarantee romantic outcomes, relationship
          compatibility, emotional accuracy, soulmate identification, twin flame
          certainty, or real-world interpersonal results.
        </p>

        <p>
          Users should not rely on AI-generated responses as factual,
          guaranteed, or professional guidance.
        </p>

        <p>
          If you require professional assistance, you should consult
          a qualified medical professional, psychologist, lawyer,
          financial advisor, relationship counselor, or other appropriate specialist.
        </p>

        <h2 style={styles.h2}>AI-Generated Content</h2>

        <p>
          Responses generated by AskUniverse are produced using artificial
          intelligence systems and may contain inaccuracies,
          incomplete information, symbolic interpretations,
          or subjective perspectives.
        </p>

        <p>
          We do not guarantee the accuracy, reliability,
          completeness, or outcomes of any AI-generated content.
        </p>

        <h2 style={styles.h2}>User Responsibility</h2>

        <p>
          Users are solely responsible for their own decisions,
          actions, interpretations, and emotional responses
          resulting from the use of AskUniverse.
        </p>

        <p>
          By using the application, you acknowledge and accept
          that all content is provided “as is”
          without warranties or guarantees of any kind.
        </p>

        <h2 style={styles.h2}>Limitation of Liability</h2>

        <p>
          SC IMAA 888 SRL and AskUniverse shall not be liable for
          any direct, indirect, incidental, emotional,
          financial, or consequential damages arising from
          the use of the application or reliance on AI-generated content.
        </p>

        <h2 style={styles.h2}>Contact</h2>

        <p>
          SC IMAA 888 SRL <br />
          Romania <br />
          <strong>support@askuniverse.app</strong>
        </p>

        <p style={styles.footer}>
          ©️ 2026 AskUniverse. All rights reserved.
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(180deg, #07122b 0%, #020816 100%)",
    color: "#fff",
    padding: "40px 20px",
  },
  card: {
    maxWidth: "900px",
    margin: "0 auto",
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: "20px",
    padding: "32px",
    lineHeight: 1.7,
  },
  backButton: {
    background: "transparent",
    color: "white",
    border: "1px solid rgba(255,255,255,0.35)",
    padding: "8px 14px",
    borderRadius: "10px",
    marginBottom: "24px",
    cursor: "pointer",
  },
  title: {
    fontSize: "40px",
    marginBottom: "8px",
  },
  date: {
    opacity: 0.8,
    marginBottom: "24px",
  },
  h2: {
    marginTop: "28px",
    fontSize: "22px",
  },
  footer: {
    marginTop: "40px",
    opacity: 0.7,
  },
};
